// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2iA0b","fileDisabled":"File_fileDisabled__2mrLq"};